<div class="container mx-auto px-4 py-6" *transloco="let t">
  <!-- Tabs -->
  <ul class="flex border-b">
    <li class="-mb-px mr-1">
      <button (click)="setActiveTab(Tabs.Usuarios)"
        [class.text-blue-500]="activeTab === Tabs.Usuarios"
        [class.border-blue-500]="activeTab === Tabs.Usuarios"
        class="bg-white inline-block py-2 px-4 border-b-2 font-semibold">
        {{ t('users.tabUsers') }}
      </button>
    </li>
    <li class="mr-1">
      <button (click)="setActiveTab(Tabs.Perfis)"
        [class.text-blue-500]="activeTab === Tabs.Perfis"
        [class.border-blue-500]="activeTab === Tabs.Perfis"
        class="bg-white inline-block py-2 px-4 border-b-2 font-semibold">
        {{ t('users.tabProfiles') }}
      </button>
    </li>
  </ul>

  <!-- Aba Usuários -->
  <div *ngIf="activeTab === Tabs.Usuarios" class="tab-content">
    <div class="mb-6 mt-4">
      <h2 class="text-xl font-bold mb-4">{{ t('users.usersTitle') }}</h2>

      <!-- Botão Criar Novo -->
      <div class="mt-4 flex space-x-4">
        <button *appHasPermission="'users.create'" (click)="createUser()" class="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600">
          {{ t('users.newUser') }}
        </button>
      </div>
    </div>

    <!-- Grade de resultados -->
    <div>
      <table class="min-w-full bg-white border">
        <thead>
          <tr class="bg-gray-200 text-left">
            <th class="py-2 px-4">{{ t('users.col.email') }}</th>
            <th class="py-2 px-4">{{ t('users.col.emailValidated') }}</th>
            <th class="py-2 px-4">{{ t('users.col.profiles') }}</th>
            <th class="py-2 px-4">{{ t('users.col.createdAt') }}</th>
            <th class="py-2 px-4 w-1/12">{{ t('users.col.actions') }}</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngIf="users.length === 0" class="border-b">
            <td colspan="5" class="py-8 px-4 text-center text-gray-500">
              {{ t('users.emptyUsers') }}
            </td>
          </tr>
          <tr *ngFor="let user of users" class="border-b hover:bg-gray-100">
            <td class="py-2 px-4">{{ user.email }}</td>
            <td class="py-2 px-4">
              <span class="px-2 py-1 rounded-full text-sm"
                [ngClass]="getEmailValidatedBadgeClass(user.emailValidated)">
                {{ getEmailValidatedText(user.emailValidated) }}
              </span>
            </td>
            <td class="py-2 px-4">{{ getProfileIdsText(user.profileIds) }}</td>
            <td class="py-2 px-4">{{ user.createdAt | date: 'dd/MM/yyyy' }}</td>
            <!-- Ícone de edição com dropdown -->
            <td class="py-2 px-4 text-center relative">
              <button class="focus:outline-none" (click)="toggleDropdown(user)">
                <i class="fas fa-ellipsis-h"></i>
              </button>
              <div *ngIf="dropdownOpen[user.id]"
                class="absolute right-0 mt-2 py-2 w-48 bg-white rounded-lg shadow-xl z-20">
                <a *appHasPermission="'users.edit'" href="#" (click)="editUser(user.id); $event.preventDefault()"
                  class="block px-4 py-2 text-gray-800 hover:bg-gray-200">
                  {{ t('users.edit') }}
                </a>
                <a *appHasPermission="'users.delete'" href="#" (click)="deleteUser(user); $event.preventDefault()"
                  class="block px-4 py-2 text-gray-800 hover:bg-gray-200">
                  {{ t('users.delete') }}
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Aba Perfis -->
  <div *ngIf="activeTab === Tabs.Perfis" class="tab-content">
    <div class="mb-6 mt-4">
      <h2 class="text-xl font-bold mb-4">{{ t('users.profilesTitle') }}</h2>

      <!-- Botão Criar Novo -->
      <div class="mt-4 flex space-x-4">
        <button (click)="createProfile()" class="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600">
          {{ t('users.newProfile') }}
        </button>
      </div>
    </div>

    <!-- Grade de resultados -->
    <div>
      <table class="min-w-full bg-white border">
        <thead>
          <tr class="bg-gray-200 text-left">
            <th class="py-2 px-4">{{ t('users.col.name') }}</th>
            <th class="py-2 px-4">{{ t('users.col.description') }}</th>
            <th class="py-2 px-4">{{ t('users.col.status') }}</th>
            <th class="py-2 px-4">{{ t('users.col.createdAt') }}</th>
            <th class="py-2 px-4 w-1/12">{{ t('users.col.actions') }}</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngIf="profiles.length === 0" class="border-b">
            <td colspan="5" class="py-8 px-4 text-center text-gray-500">
              {{ t('users.emptyProfiles') }}
            </td>
          </tr>
          <tr *ngFor="let profile of profiles" class="border-b hover:bg-gray-100">
            <td class="py-2 px-4">{{ profile.name }}</td>
            <td class="py-2 px-4">{{ profile.description || '-' }}</td>
            <td class="py-2 px-4">
              <span class="px-2 py-1 rounded-full text-sm"
                [ngClass]="getStatusBadgeClass(profile.isActive)">
                {{ getStatusText(profile.isActive) }}
              </span>
            </td>
            <td class="py-2 px-4">{{ profile.createdAt | date: 'dd/MM/yyyy' }}</td>
            <!-- Ícone de edição com dropdown -->
            <td class="py-2 px-4 text-center relative">
              <button class="focus:outline-none" (click)="toggleProfileDropdown(profile)">
                <i class="fas fa-ellipsis-h"></i>
              </button>
              <div *ngIf="profileDropdownOpen[profile.id]"
                class="absolute right-0 mt-2 py-2 w-48 bg-white rounded-lg shadow-xl z-20">
                <a href="#" (click)="editProfile(profile.id); $event.preventDefault()"
                  class="block px-4 py-2 text-gray-800 hover:bg-gray-200">
                  {{ t('users.edit') }}
                </a>
                <a href="#" (click)="deleteProfile(profile); $event.preventDefault()"
                  class="block px-4 py-2 text-gray-800 hover:bg-gray-200">
                  {{ t('users.delete') }}
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

